import { render, staticRenderFns } from "./ShopeeSellerOwn.vue?vue&type=template&id=36836bb6&scoped=true&"
import script from "./ShopeeSellerOwn.vue?vue&type=script&lang=js&"
export * from "./ShopeeSellerOwn.vue?vue&type=script&lang=js&"
import style0 from "./ShopeeSellerOwn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36836bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36836bb6')) {
      api.createRecord('36836bb6', component.options)
    } else {
      api.reload('36836bb6', component.options)
    }
    module.hot.accept("./ShopeeSellerOwn.vue?vue&type=template&id=36836bb6&scoped=true&", function () {
      api.rerender('36836bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Connector/components/Shopee/ShopeeSellerOwn.vue"
export default component.exports